<small class="d-block text-5 text-primary font-weight-bold">{{this.message | titlecase}}</small>
